"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BareHighlight = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(BareHighlight, _React$PureComponent);

  function BareHighlight() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {});

    return _this;
  }

  var _proto = BareHighlight.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.highlightCode();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    // If the text changed make sure to reset the state
    // This way we ensure that the new text is immediately displayed.
    if (prevProps.children !== this.props.children) {
      this.setState({
        highlightedCode: undefined,
        language: undefined
      });
      return;
    } // Do not call highlight.js if we already have highlighted code
    // If the children changed highlightedCode will be null


    if (this.state.highlightedCode) return;
    this.highlightCode();
  };

  _proto.getInitialCode = function getInitialCode() {
    var type = typeof this.props.children;

    if (type !== 'string') {
      throw new Error("Children of <Highlight> must be a string. '" + type + "' supplied");
    }

    return this.props.children;
  };

  _proto.getHighlightPromise = function getHighlightPromise() {
    var _this2 = this;

    var _this$props = this.props,
        highlightjs = _this$props.highlightjs,
        languages = _this$props.languages;
    return new Promise(function (resolve) {
      if (languages && languages.length === 1) {
        resolve(highlightjs.highlight(languages[0], _this2.getInitialCode()));
      } else {
        resolve(highlightjs.highlightAuto(_this2.getInitialCode(), languages));
      }
    });
  };

  _proto.highlightCode = function highlightCode() {
    var _this3 = this;

    var _this$props2 = this.props,
        languages = _this$props2.languages,
        worker = _this$props2.worker;

    if (worker) {
      worker.onmessage = function (event) {
        return _this3.setState({
          highlightedCode: event.data.value,
          language: event.data.language
        });
      };

      worker.postMessage({
        code: this.getInitialCode(),
        languages: languages
      });
    } else {
      this.getHighlightPromise().then(function (result) {
        return _this3.setState({
          highlightedCode: result.value,
          language: result.language
        });
      });
    }
  };

  _proto.render = function render() {
    var code = this.state.highlightedCode;
    var classes = (0, _clsx["default"])(this.props.className, 'hljs', this.state.language);

    if (code) {
      return /*#__PURE__*/React.createElement("pre", null, /*#__PURE__*/React.createElement("code", {
        className: classes,
        dangerouslySetInnerHTML: {
          __html: code
        }
      }));
    }

    return /*#__PURE__*/React.createElement("pre", null, /*#__PURE__*/React.createElement("code", {
      className: classes
    }, this.getInitialCode()));
  };

  return BareHighlight;
}(React.PureComponent);

exports["default"] = BareHighlight;

_defineProperty(BareHighlight, "defaultProps", {
  className: '',
  languages: [],
  worker: null
});

process.env.NODE_ENV !== "production" ? BareHighlight.propTypes = {
  children: _propTypes["default"].string.isRequired,
  className: _propTypes["default"].string,
  highlightjs: _propTypes["default"].object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  languages: _propTypes["default"].arrayOf(_propTypes["default"].string),
  worker: _propTypes["default"].object // eslint-disable-line react/forbid-prop-types

} : void 0;